import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, RouterProvider} from 'react-router-dom';
import App from './App';
import './i18n';


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
